import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MaterialModule} from '../material/material.module';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ServiceReportModule} from '../servicereport/servicereport.module';
import { BillingReportComponent } from './components/billing-report/billing-report.component';
import {BillingReportService} from './services/billing-report.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    UtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceReportModule
  ],
  declarations: [BillingReportComponent],
  providers: [BillingReportService]
})
export class BillingReportModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/billing-report/billing-report.module.ts